<template>
	<div class="qrcode" v-if="isDisplay">
	  <video
		ref="video"
		id="video"
		class="scan-video"
		v-show="scanTextData.showScanBoxInfo"
		autoplay
	  ></video>
	  <div class="scan-img" v-show="scanTextData.showScanBoxInfo">
		<div class="scan-frame">
		  <span class="left-t"></span>
		  <span class="right-t"></span>
		  <span class="left-b"></span>
		  <span class="right-b"></span>
		  <span class="cross-line"></span>
		</div>
	  </div><div class="scan-tip" v-show="scanTextData.showScanBoxInfo">
		{{ scanTextData.tipMsg }}
	  </div>
	</div>
  </template>
  
  <script>
  import { BrowserMultiFormatReader } from "@zxing/library";
  import { Dialog,Toast  } from 'vant';
  import bus from '../../util/eventBus'

  export default {
	name: "scanCodePage",
	data() {
	  return {
		scanTextData: {
		  loadingShow: false,
		  codeReader: null,
		  scanText: "",
		  vin: null,
		  tipMsg: "将二维码置于屏幕中，即可识别",
		  tipShow: false,
  
		  showScanBox: false,
		  showScanBoxInfo: false,
		},
		isDisplay:false,
		hasBind: false,
		dataObj: { qrCodeId: undefined },
		success:null,
		cancel:null
	  };
	},
	components: {},

	created() {
	  window.addEventListener('beforeunload', this.cancelScan);
	},
	destroyed(){
		window.removeEventListener('popstate', this.back, false)
		this.cancelScan();
	},
	beforeUnmount() {
		this.cancelScan();
	},
  
	methods: {
	  open(){
		if (window.history && window.history.pushState) {
			history.pushState(null, null, document.URL)
			window.addEventListener('popstate', this.back, false)
		}

		return new Promise(async (res,rej)=>{
			this.res = res;
			this.rej = rej;

			await this.toScanCode();
		});
	  },
	  async toScanCode() {
		this.isDisplay = true;
		this.scanTextData.codeReader = new BrowserMultiFormatReader();
		this.scanTextData.showScanBox = true;
		await this.openScan();
	  },
	  async back() {
		this.cancelScan();
		/*
		if(await this.$sysUtil.dialog.showConfirmDialog('检测到未保存的内容，是否在离开页面前保存修改？') != 'ok'){
			this.cancelScan();
			this.$router.back();
		}*/
	},
	  cancelScan() {
		
		//识别完停止使用摄像头
		//let Video =   document.getElementById("video");
		//Video.srcObject.getTracks()[0].stop();
		if(this.scanTextData.codeReader){
			this.scanTextData.codeReader.reset(); // 重置
			this.scanTextData.showScanBox = false;
			setTimeout(() => {
				this.scanTextData.showScanBoxInfo = false;
				bus.$emit('scanDialogQuit');
			}, 500);
		}
	  },
  
	  async openScan() {
		this.scanTextData.codeReader
		  .getVideoInputDevices()
		  .then((videoInputDevices) => {
			this.scanTextData.tipShow = true;
			this.scanTextData.tipMsg = "正在调用摄像头...";
			console.log("videoInputDevices", videoInputDevices);
			// 默认获取第一个摄像头设备id
			let firstDeviceId = videoInputDevices[0].deviceId;
			// 获取第一个摄像头设备的名称
			const videoInputDeviceslablestr = JSON.stringify(
			  videoInputDevices[0].label
			);
			if (videoInputDevices.length > 1) {
			  // 判断是否后置摄像头
			  if (videoInputDeviceslablestr.indexOf("back") > -1) {
				firstDeviceId = videoInputDevices[0].deviceId;
			  } else {
				firstDeviceId = videoInputDevices[1].deviceId;
			  }
			}
			this.decodeFromInputVideoFunc(firstDeviceId);
		  })
		  .catch((err) => {
			this.scanTextData.tipShow = false;
			console.error(err);
		  });
	  },
	  decodeFromInputVideoFunc(firstDeviceId) {
		this.scanTextData.codeReader.reset(); // 重置
		this.scanTextData.scanText = "";
		this.scanTextData.codeReader.decodeFromInputVideoDeviceContinuously(
		  firstDeviceId,
		  "video",
		  (result, err) => {
			this.scanTextData.tipMsg = "将二维码置于屏幕中，即可识别";
			this.scanTextData.scanText = "";
			setTimeout(() => {
			  this.scanTextData.showScanBoxInfo = true;
			}, 200);
			if (result) {
			  // console.log('扫描结果', result.text);
			  if (result.text) {
				// console.log('扫描结果11', result.text);
				// this.scanTextData.showScanBox = false
				// this.scanTextData.showScanBoxInfo = false
				// this.scanTextData.scanText = result.text
				// //这里扫描出结果可以调用你想要的方法
				// //识别完停止使用摄像头
				// let Video = document.getElementById("video");
				// Video.srcObject.getTracks()[0].stop()
				// this.scanTextData.codeReader.reset(); // 重置
				let decodedText = result.text;
				this.isDisplay = false;

				console.log(`scan resuilt:${decodedText}`)

				this.cancelScan();
				this.res(decodedText)
			  }
			} else {
			  // console.log('没出来？',result,err)
			}
			if (err && !err) {
			  this.scanTextData.tipMsg = "识别失败";
			  setTimeout(() => {
				this.scanTextData.tipShow = false;
			  }, 200);
			  console.error(err);
			}
		  }
		);
	  },
	},
  };
  </script>
  
  <style scoped>
  body {
	margin: 0;
	background-color: rgb(133, 133, 133);
  }
  .qrcode {
	position: relative;
	height: 100%;
	width: 100%;
	overflow: hidden;
  }
  .scan-index-bar {
	background-image: linear-gradient(-45deg, #42a5ff, #59cfff);
  }
  .van-nav-bar__title {
	color: #fff !important;
  }
  .scan-box {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 5;
	height: 100%;
	width: 100vw;
	
  }

  .scan-cacel {
	  position: absolute;
	  top: 30px;
	  left: 30px;
	  z-index: 9;
	  color: #fff;
	  font-size: 35px;
	}
  .scan-video {
	height: 100vh;
	width: 100vw;
	object-fit: cover;
  }
  .scan-img {
	width: 300px;
	height: 300px;
	position: fixed;
	top: 55%;
	left: 77%;
	margin-top: -200px;
	margin-left: -250px;
	z-index: 6;
	
  }

  .scan-frame {
	  width: 100%;
	  height: 100%;
	  position: relative;
	  .left-t,
	  .right-t,
	  .left-b,
	  .right-b {
		position: absolute;
		width: 80px;
		height: 80px;
	  }
	  .left-t {
		top: 0;
		left: 0;
		border-top: 2px solid #17b1b7;
		border-left: 2px solid #17b1b7;
	  }
	  .right-t {
		top: 0;
		right: 0;
		border-top: 2px solid #17b1b7;
		border-right: 2px solid #17b1b7;
	  }
	  .left-b {
		bottom: 0;
		left: 0;
		border-bottom: 2px solid #17b1b7;
		border-left: 2px solid #17b1b7;
	  }
	  .right-b {
		bottom: 0;
		right: 0;
		border-bottom: 2px solid #17b1b7;
		border-right: 2px solid #17b1b7;
	  }
	  .cross-line {
		width: 300px;
		height: 5px;
		background: linear-gradient(
		  to right,
		  rgba(255, 255, 255, 0),
		  #5dddd3,
		  rgba(255, 255, 255, 0)
		);
		position: absolute;
		top: 0;
		left: 0;
		animation: identifier_p 5s infinite;
	  }
	}

  .scan-tip {
	width: 100vw;
	text-align: center;
	margin-bottom: 10vh;
	color: white;
	font-size: 5vw;
	position: absolute;
	bottom: 50px;
	left: 0;
	color: #fff;
  }
  .page-scan {
	overflow-y: hidden;
  }
  </style>
  
  